<template>
  <div class="b-power" v-if="power">
    <b-card-text class="b-power-text">Battle Power</b-card-text>
    <b-row>
      <b-col>
        <b-card class="b-power-info mb-4 py-3 px-2" align="center" no-body>
          <div class="b-energy">
            <div class="attack" v-if="power.attack">
              <div class="is-flex">
                <b-card class="b-item" align="center" no-body>
                  <b-img :src="require('@/assets/images/attack.png')"></b-img>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Slash</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.attack.slash, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Heavy</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.attack.heavy, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Strike</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.attack.strike, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Tech</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.attack.tech, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Magic</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.attack.magic, 18, 2) }}
                  </b-card-text>
                </b-card>
              </div>
            </div>
            <div class="defense" v-if="power.defend">
              <div class="is-flex">
                <b-card class="b-item" align="center" no-body>
                  <b-img :src="require('@/assets/images/defense.png')"></b-img>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Slash</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.defend.slash, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Heavy</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.defend.heavy, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Strike</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.defend.strike, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Tech</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.defend.tech, 18, 2) }}
                  </b-card-text>
                </b-card>
                <b-card class="b-item" align="center" no-body>
                  <b-card-text class="mb-0 item-title">Magic</b-card-text>
                  <b-card-text class="mb-0 item-value"
                    >{{ utils.bigToCommon(power.defend.magic, 18, 2) }}
                  </b-card-text>
                </b-card>
              </div>
            </div>
          </div>
          <div class="b-total">
            <b-card-text class="b-total-text">Total power</b-card-text>
            <b-card-title class="mb-0 b-total-value">{{
              utils.bigToCommon(power.total, 18, 2)
            }}</b-card-title>
          </div>
        </b-card>
        <div class="b-total-mobile">
          <b-card-text class="b-total-text">Total power:</b-card-text>
          <b-card-title class="mb-0 b-total-value">{{
            utils.bigToCommon(power.total, 18, 2)
          }}</b-card-title>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "BattlePower",
  props: ["power"],
};
</script>

<style lang="scss">
.b-power {
  padding-top: 10px;
  .b-power-text {
    font-size: 30px;
    font-weight: bold;
  }
  .b-power-info {
    background-color: transparent;
    display: flex;
    flex-direction: row;
    border: 1px solid #434048;
    align-items: center;
    .b-energy {
      width: calc(100% - 150px);
      border-right: 1px solid #434048;
      .attack {
        margin-bottom: 10px;
      }
      .defense {
        margin-top: 10px;
      }
    }
    .b-total {
      width: 150px;
      text-transform: uppercase;
      font-weight: bold;
      .b-total-text {
        margin-bottom: 10px;
      }
      .b-total-value {
        font-size: 40px;
        color: #eb345f;
      }
    }
    .b-item {
      width: calc(16.666% - 8px);
      justify-content: center;
      background-color: transparent;
      border: none;
      font-weight: bold;
      img {
        max-width: 40px;
        margin: 0 auto;
      }
      .item-title {
        text-transform: uppercase;
        color: #8f8fa9;
      }
      .item-value {
        color: #fff;
        font-size: 20px;
      }
    }
  }
  .b-total-mobile {
    font-weight: bold;
    gap: 10px;
    text-transform: uppercase;
    align-items: center;
    justify-content: right;
    display: none;
    .b-total-text {
      margin-bottom: 0;
    }
    .b-total-value {
      font-size: 30px;
      line-height: 30px;
      color: #eb345f;
    }
  }
  @media (max-width: 580px) {
    .b-power-info {
      flex-flow: column;
      font-size: 14px;
      .b-energy {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px solid #434048;
        border-right: none;
        .is-flex {
          justify-content: space-between;
        }
      }
      .b-item {
        .item-value {
          font-size: 14px;
        }
      }
      .b-total {
        margin-top: 10px;
      }
    }
  }
}
</style>
